import React, { memo, useMemo } from 'react';
import PropTypes from 'prop-types';
import { Badge } from '@Sage/hoi-poi-ui';
import { getCampaignStatusBadgeType } from '../utils/campaignStatusBadge';

const CampaignLabel = memo(({ text, status, percentageCompleted }) => {
    const badgeType = useMemo(
        () =>
            getCampaignStatusBadgeType({
                statusId: status,
                text,
                percentageCompleted,
            }),
        [status, text, percentageCompleted],
    );

    if (!status || text == null || text === '') return null;

    return (
        <div className="campaign-label">
            <Badge type={badgeType}>{text}</Badge>
        </div>
    );
});

CampaignLabel.displayName = 'CampaignLabel';

CampaignLabel.propTypes = {
    percentageCompleted: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    status: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    text: PropTypes.node,
};

export default CampaignLabel;
